// DDS age-group logic for the Client section. Pure + dependency-free so the
// boundary cases (0/3/16/22, leap years, future/invalid dates) can be unit-tested
// in Node. Extracted from client_section_controller.js.

export const AGE_GUIDELINES = {
  earlyStart: { label: "Early Start (0-3 years)" },
  schoolAge:  { label: "School Age (3-15 years)" },
  transition: { label: "Transition (16-21 years)" },
  adult:      { label: "Adult (22+ years)" },
}

// Whole years from an ISO "YYYY-MM-DD" birth date to `today`, or null when the
// date is missing, malformed, impossible (e.g. 2024-02-30), before 1900, or in
// the future. Callers treat null as "unknown" and must not guess an age — the
// old code returned a bogus age (and defaulted an EMPTY dob to "Adult").
export function ageFromDateString(dateString, today = new Date()) {
  const m = String(dateString || "").match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!m) return null
  const y = +m[1], mo = +m[2], d = +m[3]
  if (mo < 1 || mo > 12 || d < 1 || d > 31 || y < 1900) return null
  const birth = new Date(y, mo - 1, d)
  // Reject rolled-over impossible dates (Feb 30 -> Mar 2, Apr 31 -> May 1, ...).
  if (birth.getFullYear() !== y || birth.getMonth() !== mo - 1 || birth.getDate() !== d) return null
  if (birth > today) return null
  let age = today.getFullYear() - y
  const md = today.getMonth() - (mo - 1)
  if (md < 0 || (md === 0 && today.getDate() < d)) age--
  return age < 0 ? null : age
}

// Bin an age into a DDS service group; a null/unknown age yields null.
export function ageGroupFromAge(age) {
  if (age === null || age === undefined) return null
  if (age < 3)  return "earlyStart"
  if (age < 16) return "schoolAge"
  if (age < 22) return "transition"
  return "adult"
}

// The label to show for a DOB, or "—" when the group is unknown (empty/invalid).
export function ageGroupLabel(dateString, today = new Date()) {
  const key = ageGroupFromAge(ageFromDateString(dateString, today))
  return key ? AGE_GUIDELINES[key].label : "—"
}
